export const actionTypes = {
	openSnackBarSuccess: "SNACKBAR_SUCCESS",
	openSnackBarInfo: "SNACKBAR_INFO",
	openSnackBarError: "SNACKBAR_ERROR",
	openSnackBarWarning: "SNACKBAR_WARNING",
	closeSnackBar: "SNACKBAR_CLEAR"
}

const initialState = {
	snackbarOpen: false,
	snackbarMessage: undefined,
	snackBarDescription: undefined,
	typeOfSnackBar: "success"
}

export const uiReducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.openSnackBarSuccess:
			return {
				...state,
				snackbarOpen: true,
				snackbarMessage: action.payload.message,
				snackBarDescription: action.payload.description,
				typeOfSnackbar: "success"
			}
		case actionTypes.openSnackBarInfo:
			return {
				...state,
				snackbarOpen: true,
				snackbarMessage: action.payload.message,
				snackBarDescription: action.payload.description,
				typeOfSnackbar: "info"
			}
		case actionTypes.openSnackBarError:
			return {
				...state,
				snackbarOpen: true,
				snackbarMessage: action.payload.message,
				snackBarDescription: action.payload.description,
				typeOfSnackbar: "error"
			}
		case actionTypes.openSnackBarWarning:
			return {
				...state,
				snackbarOpen: true,
				snackbarMessage: action.payload.message,
				snackBarDescription: action.payload.description,
				typeOfSnackbar: "warning"
			}
		case actionTypes.closeSnackBar:
			return {
				...state,
				snackbarOpen: false,
				snackbarMessage: undefined,
				snackBarDescription: undefined
			}
		default:
			return state
	}
}

export const actions = {
	showSuccessSnackBar: (message, description) => ({
		type: actionTypes.openSnackBarSuccess,
		payload: { message, description }
	}),
	showWarningSnackBar: (message, description) => ({
		type: actionTypes.openSnackBarWarning,
		payload: { message, description }
	}),
	showErrorSnackBar: (message, description) => ({
		type: actionTypes.openSnackBarError,
		payload: { message, description }
	}),
	showInfoSnackBar: (message, description) => ({
		type: actionTypes.openSnackBarInfo,
		payload: { message, description }
	}),
	closeSnackBar: () => ({ type: actionTypes.closeSnackBar })
}
